import {RootState} from '@/store'
import {actions} from "@/store/modules/processesManagement/actions";
import {getters} from "@/store/modules/processesManagement/getters";
import {mutations} from "@/store/modules/processesManagement/mutations";
import {Module} from 'vuex'

export interface ProcessesManagementState extends BaseState {
}

export const initialState = function (): ProcessesManagementState {
  return {
    isEmpty: true
  }
}

export const processesManagement: Module<ProcessesManagementState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}